/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import CreateLayer from "../editor_sidebar/CreateLayer";
import ModalApiInput from "../editor_api/ModalApiInput";
import UPLOAD_LAYER from "../editor_upload_data/UPLOAD_LAYER";
import CreateFolder from "../editor_sidebar/CreateFolder";
import JOIN_TABLE from "../editor_search_import/JOIN_TABLE";
import NotificationProject from "../editor_trivial/NotificationProject";
import SEARCH_LAYER from "../editor_search_import/SEARCH_LAYER";
import FormFeature from "../editor_table/TableEditViaForm";

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

const ACTION_LAYER = ({
  properties: { geo_project_link } = {},
  layer: { modal_link_edit } = {},
  auth: { language: authLanguage } = {},
  mode,
  set_value_layer,
}) => {
  const [modalCreateLayer, setModalCreateLayer] = useState(false);
  const [modalImportLayer, setModalImportLayer] = useState(false);
  const [modalApiBridging, setModalApiBridging] = useState(false);
  const [modalJoinTable, setModalJoinTable] = useState(false);
  const [modalCreateFolder, setModalCreateFolder] = useState(false);
  const [modalAttachLayer, setModalAttachLayer] = useState(false);

  const toggle_link_edit = () => {
    set_value_layer({
      key: "modal_link_edit",
      value: !modal_link_edit,
    });
  };

  const toggleAttachLayer = () => {
    setModalAttachLayer(!modalAttachLayer);
  };

  const toggleCreateLayer = () => {
    setModalCreateLayer(!modalCreateLayer);
  };

  const toggleImportLayer = () => {
    setModalImportLayer(!modalImportLayer);
  };

  const toggleApiBridging = () => {
    setModalApiBridging(!modalApiBridging);
  };

  const toggleJoinTable = () => {
    setModalJoinTable(!modalJoinTable);
  };

  const toggleCreateFolder = () => {
    setModalCreateFolder(!modalCreateFolder);
  };

  //local storage
  const language = window.localStorage?.language || authLanguage;

  //content
  const modal_link_edit_content = modal_link_edit && (
    <Modal
      modalSize="large"
      isOpen={modal_link_edit}
      onClose={toggle_link_edit}
    >
      <div className="box-body">
        <FormFeature />
      </div>
    </Modal>
  );

  const modalAttachLayerContent = modalAttachLayer && (
    <Modal
      modalSize="medium"
      isOpen={modalAttachLayer}
      onClose={toggleAttachLayer}
      title="Import Data"
    >
      <div className="box-body">
        <SEARCH_LAYER />
      </div>
    </Modal>
  );

  let final_content = (
    <main>
      <section
        className="inputBox background_grey_light"
        id="new_layer"
        style={{ marginTop: "5px", height: modalCreateLayer ? "100%" : "19px" }}
      >
        <div
          onClick={toggleCreateLayer}
          style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
          data-mapid="clickNewLayer"
        >
          <div className="noselect" style={{ flex: 1 }}>
            {dict["New Layer"][language]}
          </div>
          <div>
            <svg
              style={{
                transition: "transform 0.5s ease 0s",
                transform: `${modalCreateLayer ? "rotate(180deg)" : "rotate(0deg)"}`,
              }}
              xmlns="http://w3.org"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
            {/* <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="caret-down"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              style={{
                width: "1.25rem",
                height: "1.25rem",
                transition: "transform 0.5s ease 0s",
                transform: `${
                  modalCreateLayer ? "rotate(180deg)" : "rotate(0deg)"
                }`,
              }}
            >
            <polyline points="6 9 12 15 18 9"></polyline>
              <path
                fill="currentColor"
                d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
              ></path>
            </svg> */}
          </div>
        </div>
        <CreateLayer />
      </section>

      <section
        className="inputBox background_grey_light"
        id="import_layer"
        style={{ height: modalImportLayer ? "100%" : "19px" }}
      >
        <div
          onClick={toggleImportLayer}
          style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
          data-mapid="clickUploadFile"
        >
          <div className="noselect" style={{ flex: 1 }}>
            {dict["Upload File"][language]}
          </div>
          <div>
            <svg
              style={{
                transition: "transform 0.5s ease 0s",
                transform: `${modalImportLayer ? "rotate(180deg)" : "rotate(0deg)"}`,
              }}
              xmlns="http://w3.org"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
        </div>
        <UPLOAD_LAYER />
      </section>

      <section
        className="inputBox background_grey_light"
        id="api_bridging"
        style={{ height: modalApiBridging ? "100%" : "19px" }}
      >
        <div
          onClick={toggleApiBridging}
          style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
        >
          <div className="noselect" style={{ flex: 1 }}>
            {dict["Connect to API"][language]}
          </div>
          <div>
            <svg
              style={{
                transition: "transform 0.5s ease 0s",
                transform: `${modalApiBridging ? "rotate(180deg)" : "rotate(0deg)"}`,
              }}
              xmlns="http://w3.org"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
            {/* <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="caret-down"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              style={{
                width: "1.25rem",
                height: "1.25rem",
                transition: "transform 0.5s ease 0s",
                transform: `${modalApiBridging ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
              }}
            >
              <path
                fill="currentColor"
                d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
              ></path>
            </svg> */}
          </div>
        </div>
        <ModalApiInput />
      </section>

      <section
        className="inputBox background_grey_light"
        id="join_table"
        style={{ height: modalJoinTable ? "100%" : "19px" }}
      >
        <div
          onClick={toggleJoinTable}
          style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
          data-mapid="clickJoin"
        >
          <div className="noselect" style={{ flex: 1 }}>
            {dict["Join Table"][language]}
          </div>
          <div>
            <svg
              style={{
                transition: "transform 0.5s ease 0s",
                transform: `${modalJoinTable ? "rotate(180deg)" : "rotate(0deg)"}`,
              }}
              xmlns="http://w3.org"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
            {/* <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="caret-down"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              style={{
                width: "1.25rem",
                height: "1.25rem",
                transition: "transform 0.5s ease 0s",
                transform: `${modalJoinTable ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
              }}
            >
              <path
                fill="currentColor"
                d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
              ></path>
            </svg> */}
          </div>
        </div>
        <JOIN_TABLE />
      </section>

      <section
        className="inputBox background_grey_light"
        id="attach_layer"
        style={{ height: "20px" }}
      >
        <main
          className="text_collapse noselect"
          style={{ marginBottom: "10px" }}
          onClick={toggleAttachLayer}
        >
          <section style={{ display: "flex" }}>
            <div
              className="noselect"
              style={{ whiteSpace: "nowrap" }}
              data-mapid="clickImportData"
            >
              {dict["Attach Layer"][language]}
            </div>
          </section>
        </main>
      </section>

      <section
        className="inputBox background_grey_light"
        id="new_folder"
        style={{ height: modalCreateFolder ? "100%" : "19px" }}
      >
        <div
          onClick={toggleCreateFolder}
          style={{ display: "flex", paddingBottom: 4, cursor: "pointer" }}
          data-mapid="clickNewFolder"
        >
          <div className="noselect" style={{ flex: 1 }}>
            {dict["New Folder Layer"][language]}
          </div>
          <div>
            <svg
              style={{
                transition: "transform 0.5s ease 0s",
                transform: `${modalCreateFolder ? "rotate(180deg)" : "rotate(0deg)"}`,
              }}
              xmlns="http://w3.org"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
            {/* <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="caret-down"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              style={{
                width: "1.25rem",
                height: "1.25rem",
                transition: "transform 0.5s ease 0s",
                transform: `${modalCreateFolder ? "rotate(180deg)" : "rotate(0deg)"
                  }`,
              }}
            >
              <path
                fill="currentColor"
                d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
              ></path>
            </svg> */}
          </div>
        </div>
        <CreateFolder />
      </section>
      <hr />
    </main>
  );

  if (mode === "notif") {
    final_content = <NotificationProject geo_project_link={geo_project_link} />;
  }

  return (
    <main>
      {modalAttachLayerContent}
      {modal_link_edit_content}
      {final_content}
    </main>
  );
};

const map_state_to_props = (state) => ({
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
});

export default connect(map_state_to_props, {
  set_value_layer,
})(ACTION_LAYER);
